import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import { EScrollBannerStatus, IScrollBanner } from 'models/scrollBanners'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'

interface IScrollBannerBody {
  // при редактировании фото опциональны: не переданы — остаются прежние
  photo?: File
  photo_desktop?: File
  fixed_position?: boolean
  end_date?: string // YYYY-MM-DD
  webUrl?: string
}

export const scrollBannersApi = {
  getScrollBanners: (): Promise<AxiosResponse<IScrollBanner[]>> =>
    privateApi.get('/admin/scroll-banner'),
  createScrollBanner: (data: IScrollBannerBody) =>
    privateApi.post('/admin/scroll-banner', getNormalizedFormData(data)),
  updateScrollBanner: (id: string, data: IScrollBannerBody) =>
    privateApi.patch('/admin/scroll-banner', getNormalizedFormData(data), { params: { _id: id } }),
  updateScrollBannerStatus: (id: string, status: EScrollBannerStatus) =>
    privateApi.patch('/admin/scroll-banner', { status }, { params: { _id: id } }),
  // ids — незакреплённые активные в новом порядке
  reorderScrollBanners: (ids: string[]) =>
    privateApi.patch('/admin/scroll-banner/order', { ids }),
  deleteScrollBanner: (id: string) =>
    privateApi.delete('/admin/scroll-banner', { params: { _id: id } })
}
